import styled from 'styled-components'
const Container = styled.div`
    font-size: 14px;
    padding: 20px 0;
`
const PrivacyAgreement = () => (
    <Container>
        By clicking &quot;Upload to GIPHY&quot; you agree to our{' '}
        <a href="/terms" target="_blank">
            terms of service
        </a>
        ,{' '}
        <a href="/community-guidelines" target="_blank">
            community guidelines
        </a>
        , and our Privacy Policy.
    </Container>
)

export default PrivacyAgreement
